enum Color {

  NONE = '',
  SAFETY_BLUE = 'safety_blue',
  SAFETY_GREEN = 'safety_green',
  SAFETY_NEUTRAL = 'safety_neutral',
  SAFETY_ORANGE = 'safety_orange',
  SAFETY_RED = 'safety_red',
  SAFETY_YELLOW = 'safety_yellow',

}

export default Color;
